import { useQuery } from "react-query";
import { getBusinessTypes } from "../../../../../actions/Utilities/BusinessType";

const useGetBusinessTypes = () => {
  return useQuery("GetBusinessTypes", () => getBusinessTypes(), {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export default useGetBusinessTypes;
